import { KeyboardEvent as ReactKeyboardEvent, MouseEvent as ReactMouseEvent } from "react";

// https://github.com/vercel/next.js/issues/37362
// this helps for cypress tests when the navigation between hashed is too fast
export const catchCancelledPush = (promise: Promise<boolean>) => {
  return promise.catch((error: { cancelled: boolean }) => {
    if (!error.cancelled) {
      throw error;
    }
  });
};

export const isModifiedClick = (event: ReactMouseEvent | ReactKeyboardEvent): boolean => {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return true;
  }
  const mouseEvent = event as ReactMouseEvent;
  return mouseEvent.button === 1 || (mouseEvent.nativeEvent as MouseEvent).which === 2;
};

export type QueryObject = Record<string, string | string[] | undefined>;

/**
 * Builds a URL string from asPath while replacing query params.
 * - Uses asPath instead of pathname to preserve real dynamic segments (e.g., `/bulk-emails/123`).
 * - Removes undefined values, keeps arrays, and preserves existing hash fragments.
 */
export const buildUrlWithQuery = (asPath: string, nextQuery: QueryObject): string => {
  const [pathAndSearch, hashFragment] = asPath.split("#");
  const [pathOnly] = pathAndSearch.split("?");
  const searchParams = new URLSearchParams();

  Object.entries(nextQuery).forEach(([key, value]) => {
    if (value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return;
      }
      searchParams.set(key, value.join(","));
      return;
    }
    searchParams.set(key, value);
  });

  const search = searchParams.toString();
  const hash = hashFragment ? `#${hashFragment}` : "";
  return search ? `${pathOnly}?${search}${hash}` : `${pathOnly}${hash}`;
};
